<h3 class="us_title">Referral</h3>
<div class="referral__div">
	<h2>REFER AND EARN!</h2>
	<div class="referral__socials">
		<a href="#"><img src="https://d1p45eoi1yern1.cloudfront.net/social-media/facebook.svg"></a>
		<a href="#"><img src="https://d1p45eoi1yern1.cloudfront.net/social-media/twitter.svg"></a>
		<a href="#"><img src="https://d1p45eoi1yern1.cloudfront.net/social-media/telegram.svg"></a>
		<a href="#"><img src="https://d1p45eoi1yern1.cloudfront.net/social-media/whatsapp.svg"></a>
		<a href="#"><img src="https://d1p45eoi1yern1.cloudfront.net/social-media/instagram.svg"></a>
	</div>
	<p>Keep your friends close and referral friends closer! Invite your friends and family to sign up using your personal referral code (mentioned below) and get {{data?.bonus_percentage}}% of each and every one of their deposits made thereafter!</p>
</div>

	<div class="referral__copy">
		<p>Don’t wait, start making HUGE PROFITS NOW! Use my special code {{data?.referral_code}} to Sign-Up & Get a {{data?.bonus_percentage}}% Referral Bonus!</p>
		<h5>https://{{env.host.domain}}</h5>
	</div>
	<button class="copy__btn" (click)="doCopy('url')">copy <i class="icofont-copy"></i></button>

	<div class="referral__copy">
		<h4>{{data?.referral_code}}</h4>
	</div>
	<button class="copy__btn" (click)="doCopy('code')">copy <i class="icofont-copy"></i></button>

	<!-- <h6 class="note">Note* :- Maximum bonus you can receive for Referral Bonus is ₹50000.</h6>

	<h1 class="myrefferealh1">MY REFERRALS <small>(Total Referral Earned In Last 2 Months : ₹0 )</small></h1> -->